import { useCallback, useEffect, useState, type RefObject } from "react";

interface UseIsAtViewportTopOptions {
  offset?: number;
}

function useIsAtViewportTop<T extends HTMLElement>(
  ref: RefObject<T>,
  { offset = 0 }: UseIsAtViewportTopOptions,
): boolean {
  const [isAtTop, setIsAtTop] = useState<boolean>(false);

  const checkPosition = useCallback(() => {
    if (!ref.current) return;

    const element = ref.current;
    const rect = element.getBoundingClientRect();
    setIsAtTop(rect.top <= offset);
  }, [ref, offset]);

  useEffect(() => {
    checkPosition();

    window.addEventListener("scroll", checkPosition, { passive: true });

    return () => {
      window.removeEventListener("scroll", checkPosition);
    };
  }, [checkPosition]);

  return isAtTop;
}

export default useIsAtViewportTop;
